import { render } from "./TopOne.vue?vue&type=template&id=36d4bc88&scoped=true&ts=true"
import script from "./TopOne.vue?vue&type=script&lang=ts"
export * from "./TopOne.vue?vue&type=script&lang=ts"

import "./TopOne.vue?vue&type=style&index=0&id=36d4bc88&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d4bc88"]])

export default __exports__